import React from 'react';
import bars from '../../../assets/svg/bars.svg';
const SmallLoader = (props: any) => {
  return (
    <img alt="loader" className={`loader-svg ${props.className}`} src={bars} />
  );
};

export default SmallLoader;
